import Entity from '@/common/models/entity'
import Question from '@/competences/entities/question'

export default class Competence extends Entity {
  public evaluationId: string | null = null
  public title = ''
  public description = ''
  public questions: Question[] = []
  public rating: number = 0
  public isTemplate = false
  public creatorId: string | null = null
  public isGlobal = false
  public sortNr = 0
}
